import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['field']
  static values = {
    triggerSelector: String,
    show: String,
  }

  connect() {
    requestAnimationFrame(() => this.setup())
  }

  setup() {
    const trigger = document.querySelector(this.triggerSelectorValue)
    if (!trigger) return

    // Unbind old listener if needed
    if (this.boundListener) {
      trigger.removeEventListener('input', this.boundListener)
    }

    this.boundListener = this.toggle.bind(this)
    trigger.addEventListener('input', this.boundListener)

    // Initial render
    this.toggle()
  }

  toggle() {
    const trigger = document.querySelector(this.triggerSelectorValue)
    if (!trigger) return
    const show = trigger.value === this.showValue
    this.fieldTarget.classList.toggle('hidden', !show)
  }

  disconnect() {
    const trigger = document.querySelector(this.triggerSelectorValue)
    if (trigger && this.boundListener) {
      trigger.removeEventListener('input', this.boundListener)
    }
  }
}
